import {h} from 'preact';
import invoke from 'lodash.invoke';
import {getEditReviewURL} from '@util/URLUtils';
import Button from '../../common/Button';
import VoteUpButton from '../VoteUpButton';

const wrdEdit = upi.i18n.getTextFromKey( 'wrd-Edit' );
const wrdDelete = upi.i18n.getTextFromKey( 'wrd-Delete' );

const UserActions = ( props ) => {
    const {
        id,
        status,
        isOwn,
        reviewId,
        votes,
        hasVoted,
        updateReviewVotes,
        getRedirectURL
    } = props;

    if ( isOwn ) {
        return (
            <div data-testid="userActions">
                <Button
                    as={'a'}
                    href={getEditReviewURL( id )}
                    secondary
                    fillMobile
                    className="my-1 md:my-0"
                    data-testid="edit-redirect">{wrdEdit}</Button>
                <Button
                    secondary
                    fillMobile
                    className="my-1 md:my-0 md:ml-2"
                    onClick={() => invoke( props, 'onDeleteReview', id, reviewId )}
                    data-testid="delete-userAction">{wrdDelete}</Button>
            </div>
        )
    }

    return status === 1 ?
        <VoteUpButton
            id={id}
            updateReviewVotes={updateReviewVotes}
            getRedirectURL={getRedirectURL}
            className="my-1 md:my-0"
            reviewId={reviewId}
            votes={votes}
            hasVoted={hasVoted}
        />
        : null;
};

export default UserActions;